export { StaticDatePicker } from './StaticDatePicker';
export type {
  StaticDatePickerProps,
  StaticDatePickerSlots,
  StaticDatePickerSlotProps,
} from './StaticDatePicker.types';
